import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import { LinearProgress } from '@material-ui/core';
import { getTheme } from 'theme';
import AppButtonMinimal from './AppButtonMinimal';
import AppButtonMain from './AppButtonMain';

const AppDialog = (props) => {
  const {
    open = false,
    onClose = () => {
    },
    onSubmit = () => {

    },
    title = 'Dialog',
    loading,
    submitText = 'Submit',
    closeText = 'Cancel',
    children,
  } = props;

  const handleClose = (event) => {
    onClose(event);
  };

  const handleSubmit = (event) => {
    onSubmit(event);
  };

  return (
    <Dialog onClose={ handleClose } open={ open }>
      {loading && <LinearProgress />}
      <DialogTitle>{title}</DialogTitle>
      {children}
      <div style={ { padding: getTheme().spacing(2, 0), display: 'flex', justifyContent: 'space-between', flexGrow: 1 } }>
        <AppButtonMinimal
          color={ getTheme().palette.error.main }
          text={ closeText }
          disabled={ loading }
          onClick={ handleClose }
        />
        <AppButtonMain
          text={ submitText }
          onClick={ handleSubmit }
          disabled={ loading }
        />
      </div>
    </Dialog>
  );
};

export default AppDialog;
